'use strict';

angular.module('msActivityServices').service('widgetSvc', [function () {
  function getAll(activity) {
    return _.values(activity.sections).reduce(function (res, section) {
      return res.concat(section.widgets);
    }, []);
  }

  function getByUuid(activity, uuid) {
    var widget = getAll(activity).filter(function (widget) {
      return widget.uuid === uuid;
    });
    return widget.length === 1 ? widget[0] : null;
  }

  function getResponses(activity) {
    return _.values(activity.sections).reduce(function (res, section) {
      var widgets = section.widgets.filter(function (widget) {
        return !!widget.response;
      }).map(function (widget) {
        return {
          sectionUuid: section.uuid,
          widgetUuid: widget.uuid,
          submission: widget.response
        };
      });
      return res.concat(widgets);
    }, []);
  }

  function getActivitySectionImages(activity, sectionId) {
    var images = [];
    activity.sections.forEach(function (section) {
      if (section.uuid === sectionId) {
        // run thorugh the list of widgets in the upcoming section to find any images, then preload them.
        section.widgets.forEach(function (widgetObj) {
          if (widgetObj.properties.image) {
            images.push(widgetObj.properties.image);
          }
          if (widgetObj.type === 'carousel/carousel') {
            _.values(widgetObj.properties).forEach(function (sectionId) {
              images.push(getActivitySectionImages(activity, sectionId)[0]);
            });
          }
        });
      }
    });
    return images;
  }

  function getNextSection(currentActivitySection) {
    var nextSectionId = '';
    currentActivitySection.widgets.forEach(function (widgetObj) {
      if (widgetObj.properties.nextSection) {
        nextSectionId = widgetObj.properties.nextSection;
      }
    });
    return nextSectionId;
  }

  return {
    getAll: getAll,
    getByUuid: getByUuid,
    getResponses: getResponses,
    getActivitySectionImages: getActivitySectionImages,
    getNextSection: getNextSection
  };
}]);